// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__lOZ26","colMin":"styles_colMin__MJ9PM","colCheckbox":"styles_colCheckbox__1cMiY"};